import DefaultLayout from "@/views/Layout/DefaultLayout";
import i18n from "@/i18n.js";

const ecConnectionsMenu = {
    path: "/ec-connections",
    component: DefaultLayout,
    meta: {
        title: i18n.t("title.ec_connections")
    },
    children: [
        {
            path: "",
            name: "EcConnectionsIndex",
            component: () => import("@/views/EcConnections/VIndex"),
            meta: {
                title: i18n.t("title.ec_connections")
            }
        }
    ]
};

export default ecConnectionsMenu;
